
import { ref } from "vue";

export default({
    name:"changePassword",
    props:['baseUrl', 'userId'],
    setup(props:any){
        const oldPassword = ref('');
        const newPassword = ref('');
        const confirmPassword = ref('');
        const isPasswordChangeSuccessful = ref('');

        const changePassword = ()=>{
            isPasswordChangeSuccessful.value = '';
            //console.log("props.baseUrl " , props.baseUrl);
            //console.log("props.userId " , props.userId);


            if(newPassword.value != confirmPassword.value)
            {
                alert("Enter new-password does not match the confirm-password. Please enter same password in both places.");
                return;
            }
            let token = localStorage.getItem("token");
            //console.log("token ", token);
            let userLoginId = localStorage.getItem("userId") as string;
            //console.log("userLoginId ", userLoginId);

            let requestUrl = props.baseUrl + "login/ChangeControlUserPassword";
            let requestContents={
                method:"POST",
                headers:{
                    "Content-Type":"application/json",
                    "Authorization":`Bearer ${token}`
                },
                body: JSON.stringify({
                    NewPassword:newPassword.value,
                    UserPb : {
                        UserId: parseInt(userLoginId),// props.userId,
                        Password : oldPassword.value,
                        UserName:userLoginId
                    },
                }),
            };
            fetch(requestUrl, requestContents)
            .then(response => {
                let res = response.json();
                return res;
            })
            .then( res => {
                if(res.changePassword == null)
                    isPasswordChangeSuccessful.value = 'false';
                else
                    isPasswordChangeSuccessful.value = 'true';
            });
        }

        return{
            oldPassword,
            newPassword,
            confirmPassword,
            isPasswordChangeSuccessful,
            changePassword
        }
    },
});
